import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useToaster } from '@components/toaster';

import { api } from 'api';
import { useStore } from 'models/Provider';

type Props = {
  applicationId: number;
};

export function useUnRetractApplication() {
  const { applicationStore, t } = useStore();
  const { showSuccess, showError } = useToaster();

  const queryClient = useQueryClient();

  return useMutation((props: Props) => api.applications.unRetract(props.applicationId), {
    onSuccess: (_, { applicationId }) => {
      showSuccess(t('application.unretract.success'));
      setTimeout(() => queryClient.invalidateQueries(['applicants']), 2000);
      applicationStore.unRetract(applicationId);
    },
    onError: () => {
      showError(t('application.unretract.error'));
    },
  });
}
